import GetConfirmation from "../components/GetConfirmation";

export default function Confirmation() {
  return (
    <main>
      <GetConfirmation />
    </main>
  );
}
